'use client';
import { pick, isString, shallowMerge, isArray, isUndefined } from '@s7/utils';
import { getColorStyles } from './utils/getColorStyles/getColorStyles.js';
import { getTruncate } from './utils/getTruncate/getTruncate.js';
import { getLineClamp } from './utils/getLineClamp/getLineClamp.js';
import { getTextDecoration } from './utils/getTextDecoration/getTextDecoration.js';
import { rem } from '../../../modules/sizes/impl/units/units.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const getTypographyMergedVariant = (theme, variant)=>{
    const customVariant = isString(variant) ? theme.typography.variants[variant] : variant || {};
    return _extends({}, theme.typography.variants.text, customVariant);
};
// HACK: tsc compiles this >60s with proper types
const getTypographyStyles = (theme, variation, options)=>{
    var _variation_sizes, _variation_weights, _variation_spacings;
    const { size, weight, spacing, color, truncate, lineClamp, underline, strikethrough, italic, inline, preWrap, transform, align } = shallowMerge(variation, options);
    const [fontSize, lineHeight] = isArray(size) ? size : size && (variation == null ? void 0 : (_variation_sizes = variation.sizes) == null ? void 0 : _variation_sizes[size]) || [];
    return _extends({}, fontSize && {
        fontSize: rem(fontSize)
    }, (lineHeight || inline) && {
        lineHeight: inline ? 1 : rem(lineHeight)
    }, weight && {
        fontWeight: (variation == null ? void 0 : (_variation_weights = variation.weights) == null ? void 0 : _variation_weights[weight]) || weight
    }, spacing && {
        letterSpacing: (variation == null ? void 0 : (_variation_spacings = variation.spacings) == null ? void 0 : _variation_spacings[spacing]) || spacing
    }, color && getColorStyles(theme, color), truncate && getTruncate(truncate), !isUndefined(lineClamp) && getLineClamp(lineClamp), {
        textDecoration: getTextDecoration({
            underline,
            strikethrough
        })
    }, transform && {
        textTransform: transform
    }, align && {
        textAlign: align
    }, !isUndefined(italic) && {
        fontStyle: italic ? 'italic' : 'normal'
    }, !isUndefined(preWrap) && {
        whiteSpace: preWrap ? 'pre-wrap' : 'normal'
    });
};
const typography = (theme)=>(options = {}, partial = false)=>{
        const { variant, family } = options, _options = _object_without_properties_loose(options, [
            "variant",
            "family"
        ]);
        let mergedVariation = getTypographyMergedVariant(theme, variant);
        if (partial && !variant) {
            mergedVariation = pick(mergedVariation, [
                'weights',
                'spacings',
                'sizes'
            ]);
        }
        return _extends({}, !partial && {
            boxSizing: 'border-box',
            WebkitTapHighlightColor: 'transparent',
            WebkitTextFillColor: 'initial',
            fontFamily: family || (mergedVariation == null ? void 0 : mergedVariation.family)
        }, getTypographyStyles(theme, mergedVariation, _options));
    };

export { typography };
//# sourceMappingURL=typography.js.map
